import React, { Component } from "react";
import moment from "moment";
import { Button, Card, Col, Input, Row, Upload, message, Table } from "antd";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { inject } from "mobx-react";
import { CUSTOMER_CLAIM } from "../../../../../configs/api-paths";

@inject("context")
class CustomerClaim extends Component {
	state = {
		fileDescription: "",
		policyNumber: 0,
		productName: "",
		insurerName: "",
		address1: "",
		address2: "",
		city: "",
		postcode: "",
		organisationEmail: "",
		claimId: 0,
		fnolDate: null,
		status: "",
		type: "",
		description: "",
		messages: [],
	};

	componentDidMount() {
		const { quote, claim } = this.props.location;
		if (!quote || !claim) {
			message.error(`Data is not loaded, please go back and reload the claim`);
			return;
		}
		this.setState({
			policyNumber: quote.policyNumber,
			productName: quote.product.name,
			insurerName: quote.product.insurer.name,
			address1: quote.address1,
			address2: quote.address2,
			city: quote.city,
			postcode: quote.postcode,
			organisationEmail: quote.organisation.email,
			claimId: claim.id,
			fnolDate: claim.fnolDate,
			status: claim.status,
			type: claim.type,
			description: claim.description,
			messages: claim.messages,
		});
	}

	render() {
		const {
			policyNumber,
			productName,
			insurerName,
			address1,
			address2,
			city,
			postcode,
			organisationEmail,
			claimId,
			fnolDate,
			status,
			type,
			description,
			messages,
			fileDescription,
		} = this.state;
		const { TextArea } = Input;
		const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;

		const claimMessagesColumns = [
			{
				title: "Message",
				dataIndex: "content",
			},
			{
				title: "Sent By",
				dataIndex: "sentBy",
			},
			{
				title: "Sent At",
				dataIndex: "sentAt",
				sorter: {
					compare: (a, b) => a.sentAt.valueOf() > b.sentAt.valueOf(),
				},
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleString();
				},
			},
		];

		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 20,
						paddingRight: 20,
					},
				}}
			>
				<Row>
					<Col xs={24} className="portal-card">
						<Card title={<h1>Track a Claim</h1>}>
							<Row>
								<Col xs={10}>
									<p>Policy number</p>
								</Col>
								<Col xs={14}>
									<p>{policyNumber}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Product</p>
								</Col>
								<Col xs={14}>
									<p>{productName}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Insurer</p>
								</Col>
								<Col xs={14}>
									<p>{insurerName}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Property Address</p>
								</Col>
								<Col xs={14}>
									<p>
										{address1}
										<br />
										{address2}
										<br />
										{city}
										<br />
										{postcode}
									</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Date and time the incident occurred</p>
								</Col>
								<Col xs={14}>
									<p>{moment(fnolDate).toLocaleString()}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Claim Status</p>
								</Col>
								<Col xs={14}>
									<p>{status}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Type of Loss</p>
								</Col>
								<Col xs={14}>
									<p>{type}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>
										The cause of the loss or damage and full details of how it
										occurred with as much detail as possible
									</p>
								</Col>
								<Col xs={14}>
									<p>{description}</p>
								</Col>
							</Row>
							<Row style={{ marginTop: 10 }}>
								<Col xs={10}>
									<p>File description (optional)</p>
								</Col>
								<Col xs={14}>
									<TextArea
										rows={2}
										onChange={this.handleFileDescriptionInputChange}
									/>
								</Col>
							</Row>
							<Row style={{ marginTop: 10 }}>
								<Col xs={18}>
									<p>
										Attach any documentary evidence here (images, pdfs and
										documents only)
									</p>
								</Col>
								<Col xs={6}>
									<Upload
										action={BASE_API_URL + CUSTOMER_CLAIM}
										data={{
											claimId: claimId,
											policyNumber: policyNumber,
											description: fileDescription,
										}}
										onChange={this.handleUploadChange}
										onRemove={this.handleUploadOnRemove}
									>
										<Button
											style={{
												background: "#0AE320",
												borderColor: "#0AE320",
												fontSize: "13px",
												padding: "0 4px",
											}}
										>
											Upload Files
										</Button>
									</Upload>
								</Col>
							</Row>
							<Row>
								<Col xs={18} />
								<Col xs={6}>
									<Button onClick={this.handleBackToPortalButtonClick}>
										Back to Portal
									</Button>
								</Col>
							</Row>
						</Card>
					</Col>
					<Col xs={24} className="portal-card">
						<Card title={<h1>Send a new message</h1>}>
							<Row>
								<Col xs={18}>
									<TextArea id="message" rows={4} />
								</Col>
								<Col xs={6}>
									<Button
										style={{
											marginLeft: "15px",
										}}
										onClick={() =>
											this.handleSendMessageButtonClick(organisationEmail, claimId)
										}
									>
										Send message
									</Button>
								</Col>
							</Row>
						</Card>
					</Col>
					<Col xs={24} className="portal-card">
						<Card title={<h1>Messages Log</h1>}>
							<Row>
								<Col xs={24}>
									<Table
										rowKey="id"
										columns={claimMessagesColumns}
										dataSource={messages}
										pagination={false}
									/>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleSendMessageButtonClick = async (organisationEmail, claimId) => {
		if (!organisationEmail || !claimId) {
			message.error(`Data is not loaded, please go back and reload the claim`);
			return;
		}
		const { claimsService } = this.props.context;
		const messageTextArea = document.getElementById("message");
		const claimMessage = {
			content: messageTextArea.value,
			sentBy: organisationEmail,
			claim: {
				id: claimId,
			},
		};
		await claimsService.sendClaimMessage(claimMessage);
		messageTextArea.value = "";
		const messages = await claimsService.fetchClaimMessages(claimId);
		this.setState({
			messages: messages,
		});
	};

	handleUploadOnRemove = (file) => {
		const { claimDocumentService } = this.props.context;
		claimDocumentService.deleteClaimDocument(file.response);
	};

	handleFileDescriptionInputChange = (e) => {
		this.setState({
			fileDescription: e.target.value,
		});
	};

	handleUploadChange = (info) => {
		let file = info.file;

		if (file.response && file.status === "done") {
			message.success(`${info.file.name} file uploaded successfully`, 5);
		} else if (file.status === "error") {
			message.error(
				`${info.file.name} file upload failed. Error: ${info.file.response.message}`,
				10
			);
		}
	};

	handleBackToPortalButtonClick = async () => {
		const { token } = this.props.location;
		this.props.history.push(`/portal/${token}`);
	};
}

export default CustomerClaim;
